import React from 'react';
import classNames from 'classnames';

import ParsedHtml from 'buyside/components/presentation/ParsedHtml/parsedHtml';

import styles from 'buyside/components/presentation/FundProfileShowPage/FundProfileSection/Notes/notesStyles.scss';

const Notes = ({ fundProfile }) => {
  const { notes } = fundProfile;
  return (
    <div>
      <div className={styles.notesIntro}>
        <em>
          These are additional notes supplied by the fund to provide further context on the firm's
          operations, strategy, etc.
        </em>
      </div>
      <ParsedHtml html={notes}>
        {({ content, tinyMceStyles }) => (
          <div className={classNames(tinyMceStyles, styles.notesCard)}>{content}</div>
        )}
      </ParsedHtml>
    </div>
  );
};

export default Notes;
